import React from "react";
import { HelmetProvider } from "react-helmet-async";

export default function SEO({
  title,
  description,
  canonical,
  noIndex = false,
  keywords,
  ogImage = "/og-image.jpg",
  ogType = "website",
  schema
}) {
  const siteUrl = "https://ritewellness.com";
  const fullTitle = `${title} | Rite Wellness - Concierge Healthcare`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Rite Wellness",
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    description:
      "Premium concierge healthcare and wellness services offering 24/7 virtual care, preventive wellness, chronic disease management, and personalized medical attention.",
    address: { "@type": "PostalAddress", addressCountry: "IN" },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      availableLanguage: ["English", "Hindi"]
    },
    medicalSpecialty: [
      "Primary Care",
      "Preventive Medicine",
      "Mental Health",
      "Chronic Disease Management",
      "Wellness"
    ],
    sameAs: [
      "https://facebook.com/ritewellness",
      "https://twitter.com/ritewellness",
      "https://linkedin.com/company/ritewellness",
      "https://instagram.com/ritewellness"
    ]
  };

  return (
    <HelmetProvider>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={canonicalUrl} />

      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="Rite Wellness" />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      <meta name="twitter:site" content="@ritewellness" />

      <meta name="author" content="Rite Wellness" />
      <meta name="theme-color" content="#2a9d8f" />

      <script type="application/ld+json">{JSON.stringify(schema || defaultSchema)}</script>
    </HelmetProvider>
  );
}
